import { render, staticRenderFns } from "./ModalData.vue?vue&type=template&id=6526c1f9&"
import script from "./ModalData.vue?vue&type=script&lang=js&"
export * from "./ModalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports